import { useState } from "react";
import { useUpstox } from './useUpstox';
import axios from "axios";
import { BackTest } from "../../../services/auth-service/upstoxService";

export default function BacktestScreen() {
  const { auth } = useUpstox();

  const [symbol, setSymbol] = useState("NSE_INDEX|Nifty 50");
  const [strategy, setStrategy] = useState("ORB");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const runBacktest = async () => {
    if (!auth.authenticated) {
      alert("Please login to Upstox first");
      return;
    }

    setLoading(true);

    try {
      const [headers, url] = BackTest();

      const res = await axios.post(
        url,
        { symbol, strategy },
        {
          ...headers,
          withCredentials: true, // 🔥 IMPORTANT
        }
      );

      setResult(res.data);

    } catch (err) {
      console.error("Backtest error:", err);

      if (err.response?.status === 401) {
        alert("Session expired. Please login again.");
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Backtesting Engine</h2>

      <p>
        {auth.authenticated
          ? "🟢 Connected to Upstox"
          : "🔴 Not connected"}
      </p>

      {!auth.authenticated && (
        <button onClick={auth.login}>Connect Upstox</button>
      )}

      <div>
        <label>Symbol:</label>
        <input value={symbol} onChange={(e) => setSymbol(e.target.value)} />
      </div>

      <div>
        <label>Strategy:</label>
        <select value={strategy} onChange={(e) => setStrategy(e.target.value)}>
          <option value="ORB">ORB</option>
          <option value="VWAP">VWAP</option>
          <option value="MEAN">Mean Reversion</option>
          <option value="EMA">EMA</option>
          <option value="RSI">RSI</option>
          <option value="BOLL">Bollinger</option>
          <option value="VOLUME">Volume Spike</option>
        </select>
      </div>

      <button onClick={runBacktest} disabled={loading}>
        {loading ? "Running..." : "Run Backtest"}
      </button>

      {result && (
        <div style={{ marginTop: 20 }}>
          <h3>Results</h3>
          <p>Total PnL: {result.total_pnl}</p>
          <p>Trades: {result.total_trades}</p>
          <p>Win Rate: {(result.win_rate * 100).toFixed(2)}%</p>

          <table border="1">
            <thead>
              <tr>
                <th>Entry</th>
                <th>Exit</th>
                <th>PnL</th>
              </tr>
            </thead>
            <tbody>
              {result.trades.map((t, i) => (
                <tr key={i}>
                  <td>{t.entry_time}</td>
                  <td>{t.exit_time}</td>
                  <td>{t.pnl}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}